import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }

});

export const figure32 = {
chart: {
zoomType: 'xy',
animation: false,
marginTop: 50,
marginLeft: 270,
plotBackgroundColor: null,
plotBorderWidth: null,
plotShadow: false,
type: 'bar',
height: '600px',
backgroundColor: 'rgba(255, 255, 255, 0.0)',
style: {
fontFamily: 'Montserrat'
}
},

colors: ['#ffe699', '#ffc000'],

credits: {
enabled: false
},
title: {
text: null
},
subtitle: {
text: null
},

plotOptions: {
series: {
borderWidth: 0,
marker: {
symbol: 'circle',
enabled: false,
states: {
hover: {
	   enabled: true,
	   radius: 5
   }
}
}
}
},

exporting: {
enabled: false
},

xAxis: [{
reversed: true,
categories: ["Afrique subsaharienne", "Amérique latine et Caraïbes", "Asie de l’Ouest et Afrique du Nord", "Asie centrale et Asie du Sud", "Amérique du Nord et Europe", "Asie de l’Est et Asie du Sud-Est", "", "Pays les moins avancés", "Pays en développement sans littoral", "Petits pays insulaires en développement", "", "Monde"],
			  lineColor: "#d7d7d7",
			  tickColor: "#d7d7d7",
			  tickLength: 16,
labels: {
style: {
fontWeight: 'normal',
color: '#999999',
fontSize: '12px'
}
},
}],
yAxis: [{
labels: {
		format: '{value:.1f}',
style: {
		fontWeight: 'normal',
		color: '#999999',
		fontSize: '12px'
},
},
max: 1.0,
min: 0,
tickInterval: 0.2,
gridLineWidth: 2,
title: {
text: '',
style: {
color: Highcharts.getOptions().colors[1]
}
	},
}],
tooltip: {
shared: true,
useHTML: true,
hideDelay: 500,
backgroundColor: null,
borderWidth: 0,
shadow: false,
style: {
padding: 0
}
},
legend: {
enabled: false,
},

series: [      
{
name: '2015',
tooltip: {
valueSuffix: '%'
},
dataLabels: {
enabled: true,
formatter: function () {
return Highcharts.numberFormat(this.y, 2);
},
style: {
fontWeight: 'normal',
textOutline: false,
color: '#999999',
fontSize: '10px'
}
},
data: [0.15, 0.33, 0.31, 0.40, 0.41, 0.98, null, 0.22, 0.28, 0.72, null, 0.50],
},
{
name: '2021',
tooltip: {
valueSuffix: '%'
},
dataLabels: {
enabled: true,
style: {
fontWeight: 'normal',
textOutline: false,
color: '#999999',
fontSize: '10px'
}
},
data: [0.12, 0.21, 0.28, 0.37, 0.44, 0.93, null, 0.21, 0.22, 0.76, null, 0.45],
},
]
}